exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dyna-travel-time-info__time {\n  font-weight: bold;\n}\n.dyna-travel-time-info__date--day-is-changed {\n  color: red;\n}\n", ""]);

// exports
